import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavParams, PopoverController, ToastController } from '@ionic/angular';
import { OrderOutputDto, OrderService } from 'src/generated_client';

@Component({
  selector: 'app-popover-order-reject',
  templateUrl: './popover-order-reject.component.html',
  styleUrls: ['./popover-order-reject.component.scss'],
})
export class PopoverOrderRejectComponent implements OnInit {

  order: OrderOutputDto;
  selectedReason: optionsReason;

  reasons: Array<optionsReason> = [
    { 
      id: 0,
      text: 'No tenemos más stock. Disculpas'
    },
    { 
      id: 1,
      text: 'No llegamos a esa dirección. Disculpas' 
    },
    { 
      id: 2,
      text: 'Estamos cerca del cierre. Disculpas' 
    }
  ]

  constructor(
    private orderService: OrderService,
    private navParams: NavParams,
    private popoverController: PopoverController,
    private toastController: ToastController,
    private router: Router
  ) { }

  ngOnInit() {
    this.order = this.navParams.get('order');
  }

  rejectOrder() {
    this.orderService.apiOrderRejectOrderPut(this.order.cdOrder, this.selectedReason.text).subscribe(x => {
      this.dismiss();
      this.router.navigateByUrl('orders-summary');
      this.presentToast('Pedido rechazado con éxito');
    }, err => {
      this.dismiss();
      this.presentToast(err.error.error);
    })
  }

  async presentToast(message: string) {
    
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });

    toast.present();
  }

  dismiss() {
    this.popoverController.dismiss();
  }
}

class optionsReason {
  id: number;
  text: string;
}